import { Loader2, Mail, MessageSquare } from "lucide-react";

export const KIND_LABEL = {
  welcome: "Welcome", cart_save: "Cart save", order_receipt: "Receipt", order_placed: "How to pay", payment_reminder: "Payment nudge",
  owner_alert: "Owner alert", order_shipped: "Shipped", test: "Test",
  review_request: "Review ask", password_reset: "Password reset",
};

export const STATUS_STYLE = {
  sent: "text-[color:var(--bl-green)] border-[color:var(--bl-green)]/40",
  failed: "text-red-300 border-red-400/40",
  skipped: "text-white/50 border-white/20",
};

const StatusPill = ({ status, className = "" }) => (
  <span className={`font-mono text-[10px] tracking-[0.22em] uppercase border px-2 py-0.5 ${STATUS_STYLE[status] || STATUS_STYLE.skipped} ${className}`}>{status}</span>
);

export function EmailLog({ loading, log, filter }) {
  if (loading) return <div className="py-12 text-center"><Loader2 className="animate-spin text-white/40 mx-auto" /></div>;
  if (!log?.length) {
    return (
      <div className="border border-white/8 p-10 text-center">
        <Mail size={22} className="mx-auto text-white/30" />
        <div className="text-white/50 text-sm mt-4">No emails {filter === "all" ? "yet" : `with status "${filter}"`}.</div>
      </div>
    );
  }
  return (
    <div className="border border-white/8 divide-y divide-white/8" data-testid="email-log-list">
      {log.map((row, i) => (
        <div key={`${row.created_at}-${i}`} data-testid={`email-row-${i}`} className="p-4 flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <StatusPill status={row.status} />
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[color:var(--bl-gold)]">{KIND_LABEL[row.kind] || row.kind}</span>
              <span className="font-mono text-xs text-white truncate">{row.to}</span>
            </div>
            <div className="text-white/70 text-sm mt-1.5 truncate">{row.subject}</div>
            {row.error && <div className="font-mono text-[11px] text-red-300/80 mt-1 break-words">{row.error}</div>}
          </div>
          <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-white/40 shrink-0 text-right">
            {new Date(row.created_at).toLocaleString()}
            {row.provider_id && <div className="mt-1 text-white/25 normal-case tracking-normal">{row.provider_id.slice(0, 8)}…</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

export function SmsPanel({ sms }) {
  return (
    <div className="border border-white/8 p-5" data-testid="sms-panel">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <MessageSquare size={16} className={sms?.configured ? "text-[color:var(--bl-blue)]" : "text-white/30"} />
          <div>
            <div className="bl-eyebrow text-[color:var(--bl-gold)]">Post-ship SMS</div>
            <div className="text-white/70 text-sm mt-1" data-testid="sms-status">
              {sms?.configured
                ? `Live — texting tracking links from ${sms.from_number} when an order gets a tracking number.`
                : "Not connected. Add TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN and TWILIO_FROM_NUMBER to turn on tracking texts."}
            </div>
          </div>
        </div>
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40">{sms?.log?.length || 0} logged</div>
      </div>
      {sms?.log?.length > 0 && (
        <div className="mt-4 border border-white/8 divide-y divide-white/8">
          {sms.log.slice(0, 10).map((r, i) => (
            <div key={`${r.created_at}-${i}`} className="p-3 flex flex-wrap justify-between gap-2">
              <div className="min-w-0">
                <StatusPill status={r.status} className="mr-2" />
                <span className="font-mono text-xs text-white">{r.to}</span>
                {r.error && <div className="font-mono text-[11px] text-red-300/80 mt-1">{r.error}</div>}
              </div>
              <div className="font-mono text-[10px] text-white/40">{new Date(r.created_at).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
